import { inject, InjectionKey, provide } from 'vue'

export type EditNextReportDateModalPayload = {
    reportId: string,
    reportType: number,
    nextReportDate: string,
}

export type EditNextReportDateModalActions = {
    openModal: (payload: EditNextReportDateModalPayload) => void
}

export const EditNextReportDateModalInjectionKey: InjectionKey<EditNextReportDateModalActions> = Symbol(
    'EditNextReportDateModalInjectionKey',
)

export const useEditNextReportDateModal = () => {
    return inject(EditNextReportDateModalInjectionKey)
}

export const provideEditNextReportDateModal = (actions: EditNextReportDateModalActions) =>
    provide(EditNextReportDateModalInjectionKey, actions)
